<template>
    <div class="left_panel custome_table_width">
        <div
            class="panel_head_wrap d-flex align-items-center justify-content-between"
        >
            <div class="panel_heading">
                <h2 class="font_size_20 font-weight-bold">My Store (65)</h2>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <router-link :to="{ name: 'AddNewStore' }" class="font_size_20"
                    >+ Add New Store
                </router-link>
            </div>
        </div>
        <div
            class="account_table my_Store_table_box_custom manage_player_table table-responsive semibold-table mt_30 mb_50 pl_10 pr_10 mb_32"
        >
            <table class="table mb_0">
                <thead>
                    <tr>
                        <th scope="col">
                            <div
                                class="d-flex font_size_16 text_primary_blue text-uppercase"
                            >
                                Store Name
                            </div>
                        </th>
                        <th scope="col">
                            <div
                                class="d-flex font_size_16 text_primary_blue text-uppercase"
                            >
                                Participants
                            </div>
                        </th>
                        <th scope="col">
                            <div class="d-flex font_size_16">
                                <a
                                    class="text_primary_blue text-uppercase"
                                    href="#"
                                    ># Of Order<img
                                        class="pl_4"
                                        alt=""
                                        src="/maincss/images/up-down-arrow.svg"
                                /></a>
                            </div>
                        </th>
                        <th scope="col">
                            <div
                                class="font_size_16 text_primary_blue text-uppercase"
                            >
                                Start date
                            </div>
                        </th>
                        <th scope="col">
                            <div
                                class="font_size_16 text_primary_blue text-uppercase"
                            >
                                End Date
                            </div>
                        </th>
                        <th scope="col">
                            <div
                                class="font_size_16 text_primary_blue text-uppercase"
                            >
                                Action
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="font_size_16 text_primary_blue">
                                Carlsbad High School Lacrosse
                            </div>
                        </td>
                        <td>
                            <div class="font_size_16">75</div>
                        </td>
                        <td>
                            <div class="font_size_16">200</div>
                        </td>
                        <td>
                            <div class="font_size_16">Feb 24, 2021</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 19, 2021</div>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/eye_icon.svg" /></a
                                ></span>
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/$.svg" /></a
                                ></span>
                                <span class="pr_16"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/pen.svg" /></a
                                ></span>
                                <span
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg" /></a
                                ></span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="font_size_16 text_primary_blue">
                                Panera Bread of San Diego
                            </div>
                        </td>
                        <td>
                            <div class="font_size_16">320</div>
                        </td>
                        <td>
                            <div class="font_size_16">250</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 19, 2021</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 30, 2021</div>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/eye_icon.svg" /></a
                                ></span>
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/$.svg" /></a
                                ></span>
                                <span class="pr_16"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/pen.svg" /></a
                                ></span>
                                <span
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg" /></a
                                ></span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="font_size_16 text_primary_blue">
                                Store 1
                            </div>
                        </td>
                        <td>
                            <div class="font_size_16">520</div>
                        </td>
                        <td>
                            <div class="font_size_16">260</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 19, 2021</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 30, 2021</div>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/eye_icon.svg" /></a
                                ></span>
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/$.svg" /></a
                                ></span>
                                <span class="pr_16"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/pen.svg" /></a
                                ></span>
                                <span
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg" /></a
                                ></span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="font_size_16 text_primary_blue">
                                Store 1
                            </div>
                        </td>
                        <td>
                            <div class="font_size_16">520</div>
                        </td>
                        <td>
                            <div class="font_size_16">260</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 19, 2021</div>
                        </td>
                        <td>
                            <div class="font_size_16">Mar 30, 2021</div>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/eye_icon.svg" /></a
                                ></span>
                                <span class="pr_10"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/$.svg" /></a
                                ></span>
                                <span class="pr_16"
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/pen.svg" /></a
                                ></span>
                                <span
                                    ><a href="#"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg" /></a
                                ></span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <nav aria-label="pagination_wrap Page navigation example">
            <ul class="pagination justify-content-end mt-20">
                <li class="page-item previous">
                    <a class="page-link" href="#"
                        ><img
                            src="images/previous_arrow.svg"
                            alt=""
                            class="mr_10"
                        />
                        Previous</a
                    >
                </li>
                <li class="page-item active">
                    <a class="page-link" href="#">1</a>
                </li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item next active">
                    <a class="page-link" href="#"
                        >Next
                        <img src="images/next_arrow.svg" alt="" class="ml_10"
                    /></a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "MyStore",
    components: {},
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    }
};
</script>
